import * as howler from 'howler'
import { log } from './log-sidecar'
import { pubSub } from './pubSub-sidecar'
// import { settings } from '../main/se'
import { l } from '../lib/imports'
import { settings } from './settings-sidecar'
import type { Howl } from 'howler'
import { rando } from '../lib/rando-sidecar'

// export interface ISoundSprite {
//   once: (event: 'load', cb: () => void) => void
// //   on: (event: 'loaderror' | 'end', cb: (id: string, err: any) => void) => void
// //   stop: (soundKey?: string) => void
// //   play: (soundKey?: string) => void
// //   mute: (mute: boolean) => void
// // }

let soundSprite: Howl | null = null
let musicSprite: Howl | null = null
let ambientSprite: Howl | null = null

const verbose = false
const logNamespace = 'soundGeneric'

export function getSoundSprite() {
  return soundSprite
}
export function getMusicSprite() {
  return musicSprite
}
export function getAmbientSprite() {
  return ambientSprite
}

export function load(jsonAudioSprite: any, callbackOnLoaded?: () => void) {
  soundSprite = new howler.Howl({
    src: jsonAudioSprite.urls,
    sprite: jsonAudioSprite.sprite,
  })

  if (soundSprite) {
    soundSprite.once('load', () => {
      if (callbackOnLoaded) {
        callbackOnLoaded()
      }
    })
    soundSprite.on('loaderror', (id: number, err: any) => {
      log.x(logNamespace, 'error loading sound', id, err)
    })
  }
}

export function playAmbient(
  song: string,
  loop = true,
  cb: (() => void) | null = null,
) {
  if (verbose) {
    log.x(logNamespace, 'play ambient', song)
  }
  if (ambientSprite) {
    ambientSprite.stop()
    ambientSprite = null
  }
  ambientSprite = new howler.Howl({
    src: [song + '.ogg', song + 'mp3'],
    autoplay: true,
    loop: loop,
    volume: 1,
    mute: settings.get().muteMusic,
  })
  if (ambientSprite) {
    ambientSprite.on('loaderror', (id: number, err: any) => {
      log.x(logNamespace, 'error loading ambient', song, id, err)
    })
    if (cb) {
      ambientSprite.on('end', () => {
        cb()
      })
    }
  }
  return ambientSprite
}

export function stopAmbientUnmanaged(ambientSprite: Howl | null) {
  if (ambientSprite) {
    ambientSprite.stop()
    ambientSprite.unload()
    ambientSprite = null
  }
}
export function playAmbientUnmanaged(
  song: string,
  volume: number,
  loop = false,
  cb: (() => void) | null = null,
): Howl {
  if (verbose) {
    console.log('playing ambient', song)
  }
  let ambientSprite = new howler.Howl({
    src: [song + '.ogg', song + 'mp3'],
    autoplay: true,
    loop: loop,
    volume,
    mute: settings.get().muteSound,
  })
  if (ambientSprite) {
    ambientSprite.on('loaderror', (id: number, err: any) => {
      log.x(logNamespace, 'error loading ambient', song, id, err)
    })
    if (cb) {
      ambientSprite.on('end', () => {
        log.x(logNamespace, 'ambient finished', song)
        cb()
      })
    }
  }
  return ambientSprite
}

export function playMusic(
  song: string,
  loop = true,
  cb: (() => void) | null = null,
) {
  if (verbose) {
    log.x(logNamespace, 'play music', song)
  }
  if (musicSprite) {
    musicSprite.stop()
    musicSprite = null
  }

  musicSprite = new howler.Howl({
    src: [song + '.ogg', song + 'mp3'],
    autoplay: true,
    loop: loop,
    volume: 0.33,
    mute: settings.get().muteMusic,
  })
  if (musicSprite) {
    //musicSprite.once('load', () => {
    //musicSprite.play()
    //})
    musicSprite.on('loaderror', (id: number, err: any) => {
      // console.log('howl', 'loaderror', id, err)
      log.x(logNamespace, 'error loading music', song, id, err)
    })
    if (cb) {
      musicSprite.on('end', () => {
        cb()
      })
    }
  }
}

export function isSoundMuted() {
  return settings.get().muteSound
}

export function playOn(_soundSprite: Howl, soundKey: string) {
  if (isSoundMuted()) {
    return -1
  }

  if (verbose) {
    log.x(logNamespace, 'play', soundKey)
  }
  return _soundSprite.play(soundKey)
}

export function play(soundKey: string, volume = 1) {
  if (verbose) {
    log.x(logNamespace, 'play sound', soundKey)
  }
  if (isSoundMuted() || !soundSprite) {
    return -1
  }

  let id = soundSprite.play(soundKey)
  soundSprite.volume(volume, id)
  // soundSprite.rate(1, id)
}

export function playRandom(soundKeys: string[], volume = 1) {
  let sk = rando.sample(soundKeys)
  play(sk, volume)
}

export function playWithChannel(
  soundKey: string,
  channel: number,
  volume: number,
) {
  if (isSoundMuted() || !soundSprite) {
    return -1
  }
  let id = soundSprite.play(soundKey)
  soundSprite.stereo(channel, id)
  soundSprite.volume(volume, id)
}

export function playWithRandomRate(
  soundKey: string,
  baseRate: number = 1,
  variance: number = 0.125,
) {
  if (verbose) {
    log.x(logNamespace, 'play sound w rate', soundKey)
  }
  if (isSoundMuted() || !soundSprite) {
    return -1
  }

  if (verbose) {
    log.x(logNamespace, 'play', soundKey)
  }

  let id = soundSprite.play(soundKey)
  let rate = baseRate + l.random(-variance, variance, true)
  soundSprite.rate(rate, id)
}

export function stop(id: number) {
  if (soundSprite) {
    soundSprite.stop(id)
  }
}

export function stopAllSounds() {
  if (soundSprite) {
    soundSprite.stop()
  }
}

function updateMusicMute() {
  if (!musicSprite) {
    return
  }
  musicSprite.mute(settings.get().muteMusic)
}

pubSub.on('settings:update', () => {
  updateMusicMute()
  if (settings.get().muteSound) {
    stopAllSounds()
  }
})
